export default "__VITE_ASSET__ClcZUfdC__"